import React, { useMemo, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import MainHeader from "../Components/MainHeader";
import { blogs } from "../Blog";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import collectionPageSchema from "../Schema/CollectionPageSchema";
import itemListSchema from "../Schema/ItemListSchema";

const categories = [
  "All",
  "Bentonite Applications",
  "Foundry & Casting",
  "Steel & Mining",
  "Construction & Engineering",
  "Agriculture & Animal Feed",
  "Industrial Minerals",
  "Manufacturing & Industrial Uses",
  "Export & Trade",
  "Sustainability",
  "International Trade",
  "Other Minerals"
];

const BlogCommon=()=>{
    useEffect(() => {
                document.title =
                  "Blogs | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Read the Iris Impulse India Pvt. Ltd. blog for insights, industry updates, and trends on bentonite, industrial minerals, sustainability, and global market news."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/blogs");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Blogs | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Read the Iris Impulse India Pvt. Ltd. blog for insights, industry updates, and trends on bentonite, industrial minerals, sustainability, and global market news."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/blogs");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/blogs.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Blogs | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Read the Iris Impulse India Pvt. Ltd. blog for insights, industry updates, and trends on bentonite, industrial minerals, sustainability, and global market news."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/blogs.webp"
                );
              }
              }, []);

useEffect(() => {

  const sidebar = document.querySelector(".blog-sidebar");
  const layout = document.querySelector(".blog-layout");

  const handleWheel = (e) => {

    if (!sidebar || !layout) return;

    const layoutRect = layout.getBoundingClientRect();

   const layoutVisible =
  layoutRect.top < window.innerHeight - 250 &&
  layoutRect.bottom > 350;

    if (!layoutVisible) return;

    const isScrollable =
      sidebar.scrollHeight > sidebar.clientHeight;

    if (!isScrollable) return;

    const atTop = sidebar.scrollTop <= 0;

    const atBottom =
      sidebar.scrollTop + sidebar.clientHeight >=
      sidebar.scrollHeight - 2;

    /* =========================
       SCROLL DOWN
    ========================= */

    if (e.deltaY > 0 && !atBottom) {

      e.preventDefault();

      sidebar.scrollTop += e.deltaY;

      return;
    }

    /* =========================
       SCROLL UP
    ========================= */

    if (e.deltaY < 0) {

      /* SIDEBAR STILL HAS TOP CONTENT */

      if (!atTop) {

        e.preventDefault();

        sidebar.scrollTop += e.deltaY;

        return;
      }

      /* SIDEBAR FINISHED */
      return;
    }
  };

  window.addEventListener("wheel", handleWheel, {
    passive: false
  });

  return () => {
    window.removeEventListener("wheel", handleWheel);
  };

}, []);

useEffect(() => {

  const handleScroll = () => {

    const categories =
      document.querySelector(".blog-categories");

    if (!categories) return;

    if (window.scrollY > 120) {
      categories.classList.add("blog-categories-scrolled");
    } else {
      categories.classList.remove("blog-categories-scrolled");
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };

}, []);

const [activeCategory, setActiveCategory] = useState("All");

  const filteredBlogs = useMemo(() => {

    if (activeCategory === "All") {
      return blogs;
    }

    return blogs.filter((blog) =>
      blog.category.includes(activeCategory)
    );

  }, [activeCategory]);

  const latestBlog = filteredBlogs[0];

  const sidebarBlogs = filteredBlogs.slice(1, 5);


  const otherBlogs = filteredBlogs.slice(5);
  const isAllCategory = activeCategory === "All";

  const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Blogs",
    },
  ],
});
const blogPageUrl = "https://irisimpulse.com/blogs";
const collectionData = collectionPageSchema({
  url: blogPageUrl,
  title: "Blogs | Iris Impulse India Pvt. Ltd.",
  description:
    "Read the Iris Impulse India Pvt. Ltd. blog for insights, industry updates, and trends on bentonite, industrial minerals, sustainability, and global market news.",
  image: "https://irisimpulse.com/Images/blogs.webp",

  items: blogs.map((blog) => ({
    name: blog.title,
    url: `${blogPageUrl}/${blog.url}`,
    image: blog.image
      ? blog.image.startsWith("http")
        ? blog.image
        : `https://irisimpulse.com/${blog.image.replace(/^\/+/, "")}`
      : undefined,
  })),
});
const itemListData = itemListSchema({
  url: blogPageUrl,
  name: "Iris Impulse India Pvt. Ltd. Blogs",
  description: "Read the Iris Impulse India Pvt. Ltd. blog for insights, industry updates, and trends on bentonite, industrial minerals, sustainability, and global market news.",
  items:blogs.map((blog) => ({
    name: blog.title,
    url: `${blogPageUrl}/${blog.url}`,
    image: blog.image
      ? blog.image.startsWith("http")
        ? blog.image
        : `https://irisimpulse.com/${blog.image.replace(/^\/+/, "")}`
      : undefined,
  })),
});
    return(
        <>

      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={collectionData} />
      <SchemaMarkup data={itemListData} />

        <MainHeader />

        <motion.section className="blog-common-section container">

        {/* =========================
           CATEGORY BUTTONS
        ========================= */}

       <motion.div
  className="blog-categories"
  variants={staggerContainer}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
>

  {categories.map((category, index) => (
    <motion.button
      key={index}
      className={`outline-btn ${
        activeCategory === category ? "active" : ""
      }`}
    onClick={() => {

  setActiveCategory(category);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

}}
      variants={fadeUp}
      whileHover={{
        y: -3,
        scale: 1.03,
      }}
      whileTap={{
        scale: 0.96,
      }}
      transition={{
        duration: 0.2,
      }}
    >
      {category}
    </motion.button>
  ))}

</motion.div>

        {/* =========================
           TOP LAYOUT
        ========================= */}

       {isAllCategory ? (
  <>
    <div className="blog-layout">

      {/* LEFT SIDE */}

      {latestBlog && (
        <div className="blog-main">

          <h1 className="blog-heading">
            {latestBlog.title}
          </h1>

          <p className="section-text">
            {latestBlog.description}
          </p>

          <Link
            to={`/blogs/${latestBlog.url}`}
            className="underline-btn"
          >
            Read More
          </Link>

          <div className="blog-main-image-wrapper">
            <img
              src={latestBlog.image}
              alt={`${latestBlog.title} | Iris Impulse India Pvt. Ltd.`}
              className="blog-main-image"
            />
          </div>

        </div>
      )}

      {/* RIGHT SIDEBAR */}

      <div className="blog-sidebar">

        {sidebarBlogs.map((blog) => (
          <div className="blog-sidebar-card" key={blog.id}>

            <div className="blog-sidebar-image-wrapper">
              <img
                src={blog.image}
                alt={`${blog.title} | Iris Impulse India Pvt. Ltd.`}
                className="blog-sidebar-image"
              />
            </div>

           <div className="blog-sidebar-content">

 

  <h2 className="blog-sidebar-heading">
    {blog.title}
  </h2>

  <p className="section-text">
    {blog.description}
  </p>

   <div className="blog-card-top">

    <span className="blog-card-date">
      {blog.date}
    </span>

    <Link
      to={`/blogs/${blog.url}`}
      className="underline-btn"
    >
      Read More
    </Link>

  </div>

</div>
          </div>
        ))}

      </div>

    </div>

    {/* GRID */}

    <div className="blog-grid">

      {otherBlogs.map((blog, index) => (
<div
  className={`blog-grid-card ${
    index % 3 === 1
      ? "blog-grid-card-center"
      : ""
  }`}
  key={blog.id}
>

  <div className="blog-sidebar-image-wrapper">
    <img
      src={blog.image}
      alt={`${blog.title} | Iris Impulse India Pvt. Ltd.`}
      className="blog-sidebar-image"
    />
  </div>

  <div className="blog-sidebar-content">

   

    <h2 className="blog-sidebar-heading">
      {blog.title}
    </h2>

    <p className="section-text">
      {blog.description}
    </p>

     <div className="blog-card-top">

      <span className="blog-card-date">
        {blog.date}
      </span>

      <Link
        to={`/blogs/${blog.url}`}
        className="underline-btn"
      >
        Read More
      </Link>

    </div>

  </div>

</div>
      ))}

    </div>
  </>
) : (

  /* =========================
     CATEGORY BLOG GRID
  ========================= */

  <div className="blog-grid category-blog-grid">

    {filteredBlogs.map((blog, index) => (
<div
  className={`blog-grid-card ${
    index % 3 === 1
      ? "blog-grid-card-center"
      : ""
  }`}
  key={blog.id}
>

  <div className="blog-sidebar-image-wrapper">
    <img
      src={blog.image}
      alt={`${blog.title} | Iris Impulse India Pvt. Ltd.`}
      className="blog-sidebar-image"
    />
  </div>

  <div className="blog-sidebar-content">

    <div className="blog-card-top">

      <span className="blog-card-date">
        {blog.date}
      </span>

      <Link
        to={`/blogs/${blog.url}`}
        className="underline-btn"
      >
        Read More
      </Link>

    </div>

    <h2 className="blog-sidebar-heading">
      {blog.title}
    </h2>

    <p className="section-text">
      {blog.description}
    </p>

  </div>

</div>
    ))}

  </div>
)}



      </motion.section>
        </>
    )
}
export default BlogCommon;